/*
 *   Copyright (c) 2021 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { environment } from "src/environments/environment";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { BehaviorSubject } from "rxjs";
@Injectable({
  providedIn: "root"
})
export class RegisterService {
  private registerUrl =
    environment.config.prodServerUrl + environment.config.user.addMiniUser;
  private CheckUserUrl =
    environment.config.prodServerUrl + environment.config.user.UserCheck;
  private loginUrl =
    environment.config.prodServerUrl + environment.config.user.auth;
  private resetPass =
    environment.config.prodServerUrl + environment.config.user.Otp;
  private onboard =
    environment.config.prodServerUrl + environment.config.user.onboard;
  private flagdata =
    environment.config.prodServerUrl + environment.config.user.flagdata;
  private businessUnit =
    environment.config.prodServerUrl + environment.config.user.branches;
  private inventory =
    environment.config.prodServerUrl + environment.config.user.inventories;
  private itemMaster =
    environment.config.prodServerUrl + environment.config.user.itemMaster;
  private segments =
    environment.config.prodServerUrl + environment.config.user.segments;
  private BulkFileExample =
    environment.config.prodServerUrl +
    environment.config.bulk_url.viewloadExample;
  private category =
    environment.config.prodServerUrl + environment.config.user.category;
  private subCategory1 =
    environment.config.prodServerUrl + environment.config.user.subcategory1;
  private hsnCodes =
    environment.config.prodServerUrl + environment.config.user.hsnCodes;
  private updatePassword =
    environment.config.prodServerUrl + environment.config.user.changePassword;
  private productBrands =
    environment.config.prodServerUrl + environment.config.user.productBrand;
  private brandVariety =
    environment.config.prodServerUrl +
    environment.config.user.productBrandVarietyByProductCategory;
  private stories =
    environment.config.prodServerUrl + environment.config.user.stories;
  private evidences =
    environment.config.prodServerUrl + environment.config.user.evidences;
  private storySegments =
    environment.config.prodServerUrl + environment.config.user.segmentStories;
  private taxes =
    environment.config.prodServerUrl + environment.config.user.taxes;
  private UOM = environment.config.prodServerUrl + environment.config.user.uom;
  private getEvidenceTargets =
    environment.config.prodServerUrl +
    environment.config.user.getEvidenceTargets;

  private itemMasterGroup =
    environment.config.prodServerUrl + environment.config.user.itemMasterGroup;
  private inventoryGroup =
    environment.config.prodServerUrl + environment.config.user.inventoryGroup;
  private productBrandVariety =
    environment.config.prodServerUrl +
    environment.config.user.productBrandVariety;
  private userActivation =
    environment.config.prodServerUrl + environment.config.user.activateUser;
  private userActivationLink =
    environment.config.prodServerUrl + environment.config.user.activateUserLink;

  public desktopShow = true;
  public isSegments = false;
  public showFlags = false;
  public segmentsData;
  public k = new BehaviorSubject<number>(0);
  public flagopened = new BehaviorSubject<boolean>(false);
  clickedShortCodeFlag = "in";
  currentFlagStatus = this.flagopened.asObservable();
  currentk = this.k.asObservable();
  changeFlagTrue() {
    this.flagopened.next(true);
  }
  changeFlagFalse() {
    this.flagopened.next(false);
  }
  getBander() {
    return !this.flagopened.value;
  }
  constructor(private http: HttpClient) { }
  changeIndex(index: number) {
    this.k.next(index);
  }
  registerUser(user) {
    return this.http.post<any>(this.registerUrl, user);
  }
  checkUser(user) {
    return this.http.post<any>(this.CheckUserUrl, user);
  }
  loginUser(user) {
    return this.http.post<any>(this.loginUrl, user);
  }
  resetOtp(user) {
    return this.http.post<any>(this.resetPass, user);
  }
  onboardingData(data) {
    return this.http.post<any>(this.onboard, data);
  }
  getFlagData() {
    return this.http.get<any>(this.flagdata);
  }

  getInventory(id) {
    return this.http.get<any>(this.inventory + id);
  }
  getItemMaster(limits, pages) {
    return this.http.get<any>(this.itemMaster, {
      params: { limit: limits, page: pages }
    });
  }
  getSegments() {
    return this.http.get<any>(this.segments);
  }
  getBulkFileExample(data) {
    return this.http.get(this.BulkFileExample, {
      params: { type: data },
      responseType: "arraybuffer"
    });
  }
  getCategory(data) {
    return this.http.get<any>(this.category, { params: data });
  }
  getSubCategory1(id) {
    return this.http.get<any>(this.subCategory1 + id);
  }
  getStories() {
    return this.http.get<any>(this.stories);
  }
  getEvidences() {
    return this.http.get<any>(this.evidences);
  }
  getStorySegments(segmentId) {
    return this.http.get<any>(this.storySegments, { params: { segmentId } });
  }
  getEvidencesTags(eviObj, type) {
    if (type === "isItemMasterGroup") {
      return this.http.get<any>(this.getEvidenceTargets, {
        params: {
          evidenceId: eviObj.evidenceId,
          isItemMasterGroup: eviObj.isItemMasterGroup
        }
      });
    } else if (type === "isBusinessUnit") {
      return this.http.get<any>(this.getEvidenceTargets, {
        params: {
          evidenceId: eviObj.evidenceId,
          isBusinessUnit: eviObj.isBusinessUnit
        }
      });
    } else if (type === "isInventoryGroup") {
      return this.http.get<any>(this.getEvidenceTargets, {
        params: {
          evidenceId: eviObj.evidenceId,
          isInventoryGroup: eviObj.isInventoryGroup
        }
      });
    }
  }
  getBusinessUnit() {
    return this.http.get<any>(this.businessUnit);
  }
  getHSNCodes(key) {
    return this.http.get<any>(this.hsnCodes, { params: { hsnKey: key } });
  }
  getTaxes(key) {
    return this.http.get<any>(this.taxes, { params: { taxKey: key } });
  }
  changePassword(passwordDetails) {
    return this.http.post<any>(this.updatePassword, passwordDetails);
  }
  getUOM(key) {
    return this.http.get<any>(this.UOM, {
      params: { uomKey: key, isSimple: "true" }
    });
  }
  postUOM(data) {
    return this.http.post<any>(this.UOM, data);
  }
  getItemMasterGroup() {
    return this.http.get<any>(this.itemMasterGroup);
  }
  getInventoryGroup(id) {
    return this.http.get<any>(this.inventoryGroup, {
      params: { busUnitId: id }
    });
  }
  getbrandVariety(brand, category) {
    return this.http.get<any>(this.brandVariety, {
      params: { brandId: brand, categoryId: category }
    });
  }
  postProductBrandVariety(newBrandVariety) {
    return this.http.post<any>(this.productBrandVariety, newBrandVariety);
  }
  getItemMasterGroupById(id) {
    return this.http.get<any>(this.itemMasterGroup + "/" + id);
  }
  getInventoryGroupById(id) {
    return this.http.get<any>(this.inventoryGroup + "/" + id);
  }

  getbrandVarietyById(id) {
    return this.http.get<any>(this.productBrandVariety + "/" + id);
  }
  //  getProductBrands(){
  //    return this.http.get<any>(this.productBrands);
  //  }
  createProductBrand(data) {
    return this.http.post<any>(this.productBrands, data);
  }
  clickedFlag() {
    if (this.desktopShow) {
      this.showFlags = true;
    } else {
      this.showFlags = true;
      this.flagopened.next(true);
      this.changeFlagTrue();
    }
  }
  activateUser(token, form?) {
    const httpParams = new HttpParams().set("token", token);
    if (form) {
      return this.http.post<any>(this.userActivationLink + '/' + token, form);
    } else {
      return this.http.get<any>(this.userActivation, { params: httpParams });
    }
  }
}
